import React from 'react';
import { AppBar, Toolbar, Box, Hidden, Container } from '@mui/material';
import { TopNavItems, TopNavCTAs, MobileNavItems } from './components';
import { BasicImage } from 'src/components';
import { SanityTopNav } from 'src/types/sanity/types.sanity.topNav';
import { Link } from 'gatsby';

interface TopNavProps {
  value: SanityTopNav;
}

const TopNav = ({ value }: TopNavProps) => {
  
  const desktopImage = {
    image: value.navLogoDesktop._rawImage,
    name: value.navLogoDesktop.name,
    alignSelf: value?.navLogoDesktop?.alignSelf ?? undefined,
    width: value?.navLogoDesktop?.width ?? undefined,
  };

  const mobileImage = {
    image: value.navLogoMobile._rawImage,
    name: value.navLogoMobile.name,
    alignSelf: value.navLogoMobile.alignSelf,
    width: value.navLogoMobile.width,
  };

  const navLogoRoute = value.navLogoRoute ?? '/';

  const navItems = value.navItems ?? null;
  const displayMobileMenu = value.displayMobileMenu ?? true;
  
  return (
    <>
      <AppBar
        component={'nav'}
        position={'fixed'}
        sx={{
          background: 'white',
          height: ['54px', '60px'],
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Reduce shadow intensity
          justifyContent: 'center',
        }}
      >
        <Toolbar
          variant="dense"          
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            // mx: ['0px', '24px', '32px'],
          }}
        >          

          {/********************************************************************************          
           * TOP NAV LEFT SIDE
           * -------------------------------------------------------------------------------
           * The left side of the top nav is used to display the logo in the desktop view
           * and a hamburger menu in the mobile view that will open up to the nav links
           * displayed in a left blade or drawer.
           * ******************************************************************************/}
          <Hidden mdDown>
            <Box>
              {desktopImage.image && (
                <Link to={navLogoRoute}>
                  <BasicImage value={desktopImage} />
                </Link>
              )}
            </Box>
          </Hidden>

          {displayMobileMenu && (
            <Hidden mdUp>              
              <MobileNavItems navItems={navItems} />              
            </Hidden>
          )}

          {/********************************************************************************
           * TOP CENTER SECTION
           * -------------------------------------------------------------------------------
           * The center section of the top nav is used to display the nav links or the logo
           * depending on the screen size.
           * ******************************************************************************/}
          <Hidden mdUp>
            {/* <Box border={'1px solid'}> */}
              {mobileImage.image && (
                <Link to={navLogoRoute}>
                <BasicImage value={mobileImage} />
                </Link>
              )}
            {/* </Box> */}
          </Hidden>

          <Hidden mdDown>
            <TopNavItems navItems={navItems} />
          </Hidden>

          {/********************************************************************************
           * TOP NAV CTA
           * -------------------------------------------------------------------------------
           * The CTA section is always present in the top nav regardless of the screen size.
           * ******************************************************************************/}
          <TopNavCTAs ctas={value.ctas} />          
        </Toolbar>
      </AppBar>
    </>
  );
};

export default TopNav;
